import React from "react";
import { Button, Stack } from "@mui/material";
import { Check, X } from "@phosphor-icons/react";

interface ActionButtonsProps {
  editMode: boolean;
  onEdit?: () => void;
  onCancel: () => void;
  onSave: () => void;
  saveDisabled?: boolean;
  saveLabel?: string;
  hideCancel?: boolean;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  editMode,
  onEdit,
  onCancel,
  onSave,
  saveDisabled,
  saveLabel = "Save Changes",
  hideCancel = false,
}) => {
  return (
    <>
      {!editMode && onEdit ? (
        <Button
          color="secondary"
          size="small"
          onClick={onEdit}
          sx={{ minWidth: "auto" }}
        >
          Edit
        </Button>
      ) : editMode ? (
        <Stack direction="row" spacing={2}>
          {!hideCancel && (
            <Button
              color="secondary"
              size="small"
              onClick={onCancel}
            >
              Cancel
            </Button>
          )}
          <Button
            color="primary"
            size="small"
            onClick={onSave}
            disabled={saveDisabled}
          >
            {saveLabel}
          </Button>
        </Stack>
      ) : null}
    </>
  );
};

export default ActionButtons;
